export default "__VITE_ASSET__BrlbzlpM__"